import React, { Component } from "react";
import styled from "styled-components";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import LayoutProvider from "./LayoutProvider";
import RootWrapper from "./wrapper/RootWrapper";
// import Catalog from "./catalog";
import CatalogDrag from "./catalog/CatalogDrag";
// import ItemEditor from "./editor";
import PropsEditor from "./editor/PropsEditor";
class EditorTemplate extends Component {
  componentDidMount() {}

  componentWillUnmount() {}

  handleResize = e => {};

  render() {
    return (
      <LayoutProvider {...this.props}>
        <DivContainer
          ref={container => {
            this.container = container;
          }}
        >
          {this.props.isShow && (
            <CatalogDrag
              layoutState={this.props.layoutState}
              statusForm={this.props.statusForm}
            />
          )}
          <PropsEditor
            style={styles.contentProps}
            typePage={this.props.typePage}
            marketerId={this.props.marketerId}
          />
          <LayoutEditor
            ref={box => {
              this.box = box;
            }}
          >
            <BoxEditor>
              <RootWrapper id="root" />
            </BoxEditor>
          </LayoutEditor>
        </DivContainer>
      </LayoutProvider>
    );
  }
}

const styles = {
  contentProps: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 500,
    zIndex: 1001
  }
};

const DivContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  overflow-y: hidden;
  overflow-x: hidden;
  flex: 1;
  padding-bottom: 60px;
  @media only screen and (min-width: 768px) {
    padding-bottom: 0px;
  }
`;
const LayoutEditor = styled.div`
  width: 100%;
  flex: 1;
  background-color: #ffffff;
  padding: 0px;
`;
const BoxEditor = styled.div`
  overflow-y: scroll;
  height: 100%;
`;

EditorTemplate.propTypes = LayoutProvider.propTypes;

export default DragDropContext(HTML5Backend)(EditorTemplate);



// WEBPACK FOOTER //
// ./src/editor/layout/EditorTemplate.js